import { SearchTransactionActions } from './../actions/searchTransaction';

import { SET_SEARCH_TRANSACTION } from '../constants';

export interface SearchTransactionState {
  searchTransaction: string;
}

const initialState: SearchTransactionState = {
  searchTransaction: '',
};

export const searchTransactionReducer = (
  state = initialState,
  action: SearchTransactionActions,
): SearchTransactionState => {
  switch (action.type) {
    case SET_SEARCH_TRANSACTION:
      return {
        ...state,
        searchTransaction: action.payload,
      };
    default:
      return state;
  }
};
